$(document).ready(function(){
    $('#table-returns').dataTable({
        "processing": true,
        "serverSide": true,
        "ajax": "/get-returns",
        "order": [[ 0, "desc" ]],
        "columns": [
            {data: 'id'},
            {data: 'supplier_name'},
            {data: 'reference'},
            {data: 'user_text'},
            {
                data: 'created_at',
                render: function (data, type, row) {

                    let date = new Date(data);

                    let dia = String(date.getDate()).padStart(2, '0');
                    let mes = String(date.getMonth() + 1).padStart(2, '0');
                    let anio = date.getFullYear();

                    return `${dia}-${mes}-${anio}`;
                }
            },
        ],
        "columnDefs": [
            {
                "targets": 5,
                "render": function (data, type, row, meta) {
                    console.log(row)
                    return '<button data-toggle="tooltip" data-placement="top" title="Visualizar detalle" ' +
                        'class="btn btn-primary view-detail btn-sm"' +
                        'data-row ="' + row + '"' +
                        'data-id ="' + row.id + '">' +
                        '<i class="fas fa-list"></i>' +
                        '</button>'
                }
            }],
        "language": {
            "url": "//cdn.datatables.net/plug-ins/1.10.16/i18n/Spanish.json"
        },
    });

    $("#open-modal-import-returns").on('click', function(){
        $("#modal-import-returns").modal('show')
    })


    $("#table-returns tbody").on('click', '.view-detail', function () {
        let id = $(this).data('id');
        $("#modal-detail-return").modal('show')
        $('#content-detail').load('/returns/' + id + '/detail');
    })

    $("#form-import-return").on('submit', function (e) {
        e.preventDefault();

        // Limpiar errores anteriores
        $(".item-error-supplier_uuid").text('');
        $(".item-error-reference").text('');
        $(".item-error-file").text('');

        const formData = new FormData(this);

        $.ajax({
            url: "/return-import",
            type: "POST",
            data: formData,
            processData: false,
            contentType: false,
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            beforeSend: function () {
                $('#btn-import-return')
                    .prop('disabled', true)
                    .text('Importando...');
            },
            success: function (response) {
                alertWithBtn(response.msg);
                $("#modal-import-returns").modal('hide')
                $("#table-returns").DataTable().ajax.reload();
            },
            error: function (xhr) {
                let errors = xhr.responseJSON.errors;

                $("#general-errors")
                    .addClass("d-none")
                    .html("");

                $.each(errors, function (field, messages) {

                    let span = $(".item-error-" + field);

                    if (span.length) {
                        span.text(messages[0]);
                    } else {
                        $("#general-errors")
                            .removeClass("d-none")
                            .append(`<div>${messages[0]}</div>`);
                    }

                });
            },
            complete: function () {
                $('#btn-import-return')
                    .prop('disabled', false)
                    .html('<i class="fas fa-file-import mr-1"></i> Importar');
            }
        });
    });
})
